(() => {
  const initialize = (countdown) => {
    if (countdown.dataset.initialized === 'true') return;
    countdown.dataset.initialized = 'true';

    const days = Math.max(0, Number(countdown.dataset.days) || 0);
    const hours = Math.max(0, Number(countdown.dataset.hours) || 0);
    let remaining = (days * 86400) + (hours * 3600);
    if (countdown.dataset.mockTimer === 'true') remaining += 27 * 60 + 39;

    const output = () => {
      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor((remaining % 86400) / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60,
      };

      Object.entries(values).forEach(([key, value]) => {
        const node = countdown.querySelector(`[data-countdown-${key}]`);
        if (node) node.textContent = String(value).padStart(2, '0');
      });
    };

    output();
    window.setInterval(() => {
      remaining = remaining > 0 ? remaining - 1 : (days * 86400) + (hours * 3600) + (27 * 60) + 39;
      output();
    }, 1000);
  };

  const initializeAll = (root = document) => root.querySelectorAll('[data-slide-countdown]').forEach(initialize);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initializeAll()) : initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
